import { manageCategories, TagCategory } from 'apprise-core/category';
import { useL } from 'apprise-frontend-core/intl/multilang';
import { useOracle } from 'apprise-frontend-iam/authz/oracle';
import { PermissionBox, PermissionBoxProps } from 'apprise-frontend-iam/permission/permissionbox';
import { UserPermissionModule } from 'apprise-frontend-iam/user/modules';
import { CategoryLabel } from 'apprise-frontend-tags/category/label';
import { useCategoryStore } from 'apprise-frontend-tags/category/store';
import { CategoryIcon, categoryPlural, categorySingular, TagIcon, tagType } from 'apprise-frontend-tags/constants';


// returns the module for tags, which are a dependency, on behalf of apprise-frontend-tags.
// this avoid a dependency cycle with apprise-frontend-tags (which is easier than handling the cycle).
// note: must be installed after the logged user is loaded.

export const useTagPermissionModule = (): UserPermissionModule<TagCategory> => {

    return {

        type: tagType,
        plural: categoryPlural,
        Icon: CategoryIcon,
        actionType: 'admin',
        actions: [

            { ...manageCategories, icon: <TagIcon />, shortName: "tag.action_manage_short", name: "tag.action_manage_name", labels: ["manage"], description: "tag.action_manage_desc", actionType: 'admin' }

        ],
        Box: (props: Partial<PermissionBoxProps<TagCategory>>) => {

            const oracle = useOracle()

            const store = useCategoryStore()
            const l = useL()

            const { userRange, ...rest } = props

            // not over tenant users either, filter them out from the range.
            const filteredRange = userRange?.filter(u => oracle.given(u).hasNoTenant())

            return <PermissionBox preselectWildcard
                resourcePlural={categoryPlural} resourceSingular={categorySingular}
                resourceRange={store.allCategories()}
                resourceId={c => c.id}
                resourceText={c => l(c.name)}
                resourceRender={c => <CategoryLabel bare noLink category={c} />}
                userRange={filteredRange}
                maxPrivilege={manageCategories}
                {...rest} />

        },

    }


}
